'use client';

import { AppBar, Box, Container, Toolbar } from '@mui/material';
import NormalLogo from '@/../public/logo_normal.png';
import WhiteLogo from '@/../public/logo_white.png';
import { useSearchParams } from 'next/navigation';
import { isPortalUseType, PORTAL_USE_TYPE } from '@/types/types';

export function SignInHeader() {
  const searchParams = useSearchParams();
  const useTypeParam = parseInt(searchParams.get('use_type') || '2');
  const useType = isPortalUseType(useTypeParam)
    ? useTypeParam
    : PORTAL_USE_TYPE.REQUEST_USER;

  return (
    <AppBar
      position="sticky"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor:
          useType === PORTAL_USE_TYPE.PORTAL_STAFF
            ? '#3EC9BE'
            : useType === PORTAL_USE_TYPE.REQUEST_USER
              ? '#FFFFFF'
              : undefined,
        color: useType === PORTAL_USE_TYPE.REQUEST_USER ? '#13131D' : undefined,
        boxShadow: '0px 0.5px 2px 0px #0000001A, 0px 0px 2px 0px #0000001A',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {useType === PORTAL_USE_TYPE.PORTAL_STAFF ? (
              <Box
                component="img"
                src={WhiteLogo.src}
                alt="けあログっとロゴ"
                sx={{
                  height: '64px',
                  '@media (max-width: 600px)': { height: '56px' },
                }}
              />
            ) : (
              <Box
                component="img"
                src={NormalLogo.src}
                alt="けあログっとロゴ"
                sx={{
                  height: '64px',
                  '@media (max-width: 600px)': { height: '56px' },
                }}
              />
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
